import { actionTypes } from '../actions/cotas.action';
const initialState = {
    cotas: [],
    cota: {},
    result: {
        cota: {},
        transaction: {},
        user: {}
    },
    error: {},
    success: false
}

const CotasReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.CHANGE:
        return {
            ...state,
            cota: (payload === 'clear') ? {} : {
                ...state.cota,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default CotasReducer